import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const OrdersAdministrationPageContent = lazy(() => import("./OrdersAdministrationPageContent"));

function OrdersAdministrationPageInternal() {
    return (
        <DefaultPage>
            <OrdersAdministrationPageContent />
        </DefaultPage>
    );
}

export const OrdersAdministrationPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    OrdersAdministrationPageInternal
);
